import React, { useState, useEffect, useCallback } from 'react';
import BackspaceIcon from '../icons/sf-backspace-icon';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { SFPalette } from '@/lib/color';

type RandomKeypadProps = {
  onChange: (value: string) => void;
  value: string;
  onSuccess: () => void;
};

function RandomKeypad({ onChange, value, onSuccess }: RandomKeypadProps) {
  const [numbers, setNumbers] = useState<number[]>([]);

  useEffect(() => {
    rearrange();
  }, []);

  useEffect(() => {
    if (value.length === 6) {
      onSuccess();
    }
  }, [value]);

  const rearrange = useCallback(() => {
    setNumbers(Array.from({ length: 10 }, (_, i) => i).sort(() => Math.random() - 0.5));
  }, []);

  const pressKey = useCallback<(key: number) => void>(
    (key) => {
      if (value.length < 6) {
        onChange(value + key);
      }
    },
    [value, onChange],
  );

  const backspace = useCallback(() => {
    onChange(value.slice(0, -1));
  }, [value, onChange]);

  return (
    <Grid container spacing={4}>
      {numbers.slice(0, 9).map((number) => (
        <Grid item xs={4} key={number}>
          <IconButton
            onClick={() => pressKey(number)}
            sx={{
              width: '100%',
            }}
          >
            <Typography variant="h4" fontSize="1.75rem" color="black">
              {number}
            </Typography>
          </IconButton>
        </Grid>
      ))}
      <Grid item xs={4} display="flex">
        <IconButton
          onClick={rearrange}
          sx={{
            width: '100%',
          }}
        >
          <Typography variant="body1" color={SFPalette.grey4}>
            재배열
          </Typography>
        </IconButton>
      </Grid>
      <Grid item xs={4}>
        <IconButton
          onClick={() => pressKey(numbers[9])}
          sx={{
            width: '100%',
          }}
        >
          <Typography variant="h4" fontSize="1.75rem" color="black">
            {numbers[9]}
          </Typography>
        </IconButton>
      </Grid>
      <Grid item xs={4} display="flex">
        <IconButton
          onClick={backspace}
          sx={{
            width: '100%',
            height: '100%',
          }}
        >
          <BackspaceIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export default RandomKeypad;
